import React, { useState } from "react";
import rehypePrism from 'rehype-prism-plus';
import CodeEditor from '@uiw/react-textarea-code-editor';
import {ABAC} from "./objects/ABAC";

type OgCodeEditorProps = {
    code: string;
    setCode: React.Dispatch<React.SetStateAction<string | undefined>>;
};

function OgCodeEditor({ code, setCode }: OgCodeEditorProps) {

    const onChangeCode = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        // console.log("Abac changed: ", event.target.value);
        setCode(event.target.value);
    }

    return (
        <CodeEditor
            value={code}
            language="js"
            placeholder="Please enter JS code."
            onChange={(evn) => onChangeCode(evn)}
            rehypePlugins={[
                [rehypePrism, { ignoreMissing: true, showLineNumbers: true }]
            ]}
            padding={15}
            style={{
                fontSize: 15,
                backgroundColor: "#f5f5f5",
                fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
            }}
        />
    );
}


export default OgCodeEditor;